export const getWaypointIconSize = (name: string): [number, number] => {
  if (name.startsWith("map_icon")) return [32, 37];
  if (name.startsWith("map_shape")) return [18, 18];
  return [44, 44];
};
